import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useLocation } from "react-router-dom";
import {
  Subscription,
  SubscriptionPriceMode,
} from "store/subscriptions/types";

export const useGetSubscription = (
  priceMode: SubscriptionPriceMode = "default",
) => {
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const subscriptions: Subscription[] = useAppSelector(
    (state) => state.subscriptions.all,
  );

  useEffect(() => {
    dispatch({ type: "GET_SUBSCRIPTIONS", priceMode });
  }, [dispatch, priceMode]);

  const index = useMemo(() => {
    const chosenSub = new URLSearchParams(search).get("subscriptionType");
    const foundedIndex = subscriptions?.findIndex(
      ({ lookupKey }) => lookupKey === chosenSub,
    );

    if (foundedIndex === -1) {
      return Math.max(subscriptions.length - 1, 0);
    }

    return foundedIndex;
  }, [search, subscriptions]);

  return { index };
};
